<template>
  <div class="dialog-mask simple-dialog" :class="{ open: isOpen }">
    <div class="dialog-content">
      <div class="dialog-header" v-if="title">{{title}}</div>
      <div class="dialog-body">
        <i class="fa fa-fw bigicon" v-if="faicon" :class="faicon"></i>
        <p>{{text}}</p>
        <div v-if="input" class="floating-label">
          <input v-model="str" placeholder=" " :type="inputType" @keypress.enter="checkIfValidAndClose"/><!--:class="{ invalid: !str }"-->
          <label>{{inputLabel}}</label>
        </div>
        <div v-if="select" class="floating-label">
          <select v-model="str" v-bind:value="str" placeholder=" " :class="{ invalid: !str }">
            <option v-for="(opt, idx) in internalOpts" :key="idx" :value="opt">{{opt.Label}}</option>
          </select>
          <label>{{inputLabel}}</label>
        </div>
      </div>
      <div class="dialog-footer">
        <button @click="sweetClose(false)" v-if="cancelLabel">{{cancelLabel1}}</button>
        <button @click="sweetClose((input || select) ? str : true)" :disabled="!validValue">{{okLabel1}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from '@/mixins/dialogMixin'

export default {
  name: 'SimpleDialog',
  mixins: [ dialogMixin ],
  data () {
    return {
      str: null
    }
  },
  props: {
    title: {
      default: null
    },
    text: {
      type: String,
      default: 'Are you sure?'
    },
    okLabel: {
      type: String,
      default: 'Confirm'
    },
    okClass: {
      type: String,
      default: ''
    },
    cancelLabel: {
      default: 'Cancel',
      required: false
    },
    input: {
      default: false
    },
    inputType: {
      type: String,
      default: 'text'
    },
    select: {
      default: false
    },
    required: {
      default: false
    },
    faicon: {
      default: null
    }
  },
  computed: {
    validValue () {
      let valid = true
      if (this.inputType && this.inputType.toLowerCase() === 'email') {
        valid = valid && this.checkEmailValidity(this.str)
      }
      if (this.required) {
        valid = this.str && valid
      }
      return valid
    },
    internalOpts () {
      if (!this.select || !this.select.opts || !this.select.opts.length) {
        return []
      }
      if (typeof this.select.opts[0] === 'string') {
        return this.select.opts.map(opt => {
          return { Label: opt }
        })
      }
      return this.select.opts
    },
    okLabel1 () {
      return this.okLabel === 'Confirm' ? this.dictValue(this.okLabel) : this.okLabel
    },
    cancelLabel1 () {
      return this.cancelLabel === 'Cancel' ? this.dictValue(this.cancelLabel) : this.cancelLabel
    },
    inputLabel () {
      let ctrl = null
      // eslint-disable-next-line brace-style
      if (this.input) { ctrl = this.input }
      else if (this.select) { ctrl = this.select }
      if (ctrl) {
        if (typeof ctrl === typeof 'a') {
          return ctrl
        }
        if (typeof ctrl === typeof {} && ctrl.label) {
          return ctrl.label
        }
      }
      return null
    }
  },
  methods: {
    checkIfValidAndClose () {
      if (this.validValue) {
        this.sweetClose((this.input || this.select) ? this.str : true)
      }
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.input) {
        if (typeof this.input === typeof {} && this.input.value) {
          this.str = '' + this.input.value
        }
        let inputEl = this.$el.querySelector('input')
        if (inputEl) {
          inputEl.focus()
        }
      } else if (this.select) {
        if (typeof this.select === typeof {} && this.select.value) {
          this.str = '' + this.select.value
        }
        let selectEl = this.$el.querySelector('select')
        if (selectEl) {
          selectEl.focus()
        }
      }
    }, 300)
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

.simple-dialog {
  .fa-check {
    color: var(--green);
  }

  .fa-close {
    color: var(--red);
  }

  .fa-exclamation-triangle {
    color: var(--orange);
  }

  .bigicon {
    font-size: 2.5rem;
    margin: 1rem auto 0;
    display: block;
  }
}

</style>
